import "./error-not-exists.scss";
import {cs} from "@Common/react/chain-services";
import * as React from "react";

export const ErrorNotExists = ({onEdit, showErrors}) => cs(
    () => (
        <div className="error-not-exists-53i">
            <div className="title" xd-qa-type="label" xd-qa-name="Mailer ID not found">
                Mailer ID not found
            </div>
            <div className="message" xd-qa-type="label" xd-qa-name="You do not have Mailer ID on file">
                You do not have Mailer ID on file
            </div>

            {showErrors && (
                <div className="error" xd-qa-type="label" xd-qa-name="Error">
                    IMB is selected. Please add Mailer ID or de-select option to continue.
                </div>
            )}

            <div className="actions">
                <button {...{
                    onClick: onEdit,
                }}
                    xd-qa-type="button"
                    xd-qa-name="UPDATE"
                >
                    UPDATE
                </button>
            </div>
        </div>
    )
);
